export const shrinkCoparentFullName = {
  methods: {
    /**
     * @description Shrink coparent name and surname if it exeeds 16 characters
     * @return {String}
     */
    MX_shrinkCoparentFullName (coparentFullName) {
      if (!coparentFullName) {
        return ''
      }
      let splitCoparentName = coparentFullName.trim().match(/\S+/g);
      let tmpName = splitCoparentName[0];
      let tmpSurname = splitCoparentName[1];

      if (tmpName.length > 16) {
        tmpName = tmpName.substr(0, 1) + '.'
      }
      if (tmpSurname.length > 16) {
        tmpSurname = tmpSurname.substr(0, 1) + '.'
      }

      return tmpName + ' ' + tmpSurname;
    }
  }
};
